import useSWR from 'swr';
import axios from 'axios';

import { getApiUrl } from '@/helpers/api';

export const useCoachActivities = (coachId) => {
  const urlStr = `${getApiUrl()}/admin/coach-activity?coachId=${coachId}`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        throw Error(err);
      }
    },
    {
      dedupingInterval: 30000, // 30 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};
